




































































































































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import PanVerticalIcon from 'vue-material-design-icons/SwapVertical.vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import VideoEditorComponent from '@/components/VideoEditorComponent.vue';
import draggable from 'vuedraggable';
import ListEditorHeader from '@/components/list/ListEditorHeader.vue';
import MaterialRecommendation from '@/components/list/MaterialRecommendation.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import ListItemShow from '@/components/list/ListItemShow.vue';
import AdminListItemModel from '@/models/AdminListItemModel';
import AdminListModel from '@/models/AdminListModel';
import ListItemModel from '@/dex-shared/models/ListItemModel';

export default Vue.extend({
  components: {
    Loading,
    pxCard,
    pxButton,
    ListItemShow,
    TrashCanOutlineIcon,
    PanVerticalIcon,
    draggable,
    MaterialRecommendation,
    ListEditorHeader,
    pxModal,
    VideoEditorComponent,
  },

  props: {
    selectedQuestions: {
      type: Array,
      default: () => [],
    },
  },

  data: function() {
    return {
      creating: true,
      loading: true,
      pushingList: false,
      recommendBoards: false,
      recommendBoardSections: false,
      questionsURLsInput: '',
      disciplineSlug: '',
      lessonSlug: '',
      showQuestionByUrl: false,
      newVideo: false,
      createdVideoId: null,
      videoSpot: null,
      videoFromPepper: false,
      isTitleFilled: false,
    };
  },

  computed: {
    ...mapGetters({
      listById: 'listById',
      idOfQuestionBySlugAndIndex: 'idOfQuestionBySlugAndIndex',
    }),
    ...mapState({
      videosFromPepper: (state: any) => state.descomplica.videosFromPepper,
    }),
    listId(): number {
      const listId = +this.$route.params.listId;
      return listId ? listId : this.cachedListId;
    },
    list(): AdminListModel {
      return this.listById(this.listId);
    },
    mutableItems: {
      get(): AdminListItemModel[] {
        if (this.list) {
          return this.list.listItems();
        }
        return [];
      },
      set(sortedItems: Array<AdminListItemModel>) {
        sortedItems.forEach(
          (listItem: AdminListItemModel, position: number) => {
            this.$store.commit('UPDATE_ENTITY_PROP', {
              id: listItem.id,
              entity: 'list_items',
              propToUpdate: 'position',
              value: position,
            });
          },
        );
      },
    },
  },

  mounted: async function() {
    this.loading = true;
    this.shownInView = !(this.selectedQuestions.length > 0);
    this.creating = this.$route.name === 'list_create' || !this.shownInView;
    let error;
    try {
      if (this.creating) {
        const listId = await this.$store.dispatch('CREATE_LIST');
        if (this.shownInView) {
          this.$router.push(this.listById(listId).editLink);
        } else {
          this.cachedListId = listId;
          await Promise.all(
            this.selectedQuestions.map((question: any, position: number) => {
              return this.$store.dispatch('CREATE_LIST_ITEM_FROM_ID', {
                questionId: question.id,
                position,
                listId,
              });
            }),
          );
        }
      } else {
        const listId = +this.$route.params.listId;
        const err = await this.$store.dispatch('PULL_LIST_BY_ID', listId);
        if (err === 404) {
          this.$router.push('/404');
        }
      }
    } catch (e) {
      error = e;
      alert(
        `Algo deu errado. Envie essas informações para os desenvolvedores: ${error}`,
      );
    }
    this.loading = false;
  },

  methods: {
    verifyTitleFilled(event) {
      this.isTitleFilled = event;
    },
    pushList: async function() {
      if (!this.pushingList && this.isTitleFilled) {
        this.pushingList = true;
        let error;
        try {
          await this.$store.dispatch('PUSH_LIST_BY_ID', this.list.id);
          this.toggleRecommendation();
        } catch (e) {
          error = e;
          alert(
            `Algo deu errado. Envie essas informações para os desenvolvedores: ${error}`,
          );
        }
        this.pushingList = false;
        if (!error) {
          if (this.creating) {
            this.recommendBoards = true;
          } else {
            this.goToList();
          }
        }
      }
    },
    cancelListEdit: async function() {
      let error;
      if (this.creating) {
        try {
          await this.$store.dispatch('DELETE_LIST', this.list.id);
        } catch (e) {
          error = e;
          alert(
            `Algo deu errrado. Envie essas informações para os desenvolvedores: ${error}`,
          );
        }
      }
      if (!error) {
        this.goToList();
      }
    },
    goToList: function() {
      return this.$router.push(this.list.viewLink);
    },
    addItemByPrompt: async function(
      type: 'article' | 'question',
      spot: 'start' | 'end',
    ) {
      const prompt = window.prompt(`id or url of ${type} `);
      if (prompt) {
        const id = prompt.match(/\d+/) ? +prompt.match(/\d+/)[0] : prompt;
        this.addItemById(type, spot, id);
      }
    },
    addVideo: async function(spot: 'start' | 'end') {
      const prompt = window.prompt(
        `kaltura/youtube id or youtube url of the vídeo `,
      );
      if (prompt) {
        const regexp = /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/;
        const providerId = prompt.match(regexp)
          ? prompt.match(regexp)[1]
          : prompt;
        const videoInfo = {
          providerId,
          providerType: prompt.match(regexp) ? 'YOUTUBE' : 'KALTURA',
        };
        this.getVideoFromBack(spot, videoInfo);
      }
    },
    getVideoFromBack: async function(
      spot: 'start' | 'end',
      videoInfo: {
        providerId: string;
        providerType: string;
        duration?: number;
        description?: string;
        name?: string;
      },
    ) {
      const videoId = await this.$store.dispatch(
        'PULL_VIDEO_FOR_LIST_ITEM',
        videoInfo.providerId,
      );

      if (videoInfo.providerType === 'KALTURA') {
        videoInfo.duration = await this.$store.dispatch(
          'PULL_KALTURA_VIDEO_DURATION',
          videoInfo.providerId,
        );
      }

      if (videoId) {
        await this.addItemById('video', spot, videoId);
      } else {
        try {
          this.createdVideoId = await this.$store.dispatch(
            'CREATE_VIDEO_FOR_LIST_ITEM',
            videoInfo,
          );
          if (this.videoFromPepper) {
            await this.addItemById('video', spot, this.createdVideoId);
          } else {
            this.videoSpot = spot;
            this.newVideo = true;
          }
        } catch (e) {
          alert(
            `Algo deu errado. Erro: ${e}. Se esta mensagem de erro não estiver clara, envie essa mensagem para os desenvolvedores`,
          );
        }
      }
    },
    openAddVideoPepperModal: async function() {
      this.videoFromPepper = true;
    },
    addVideosFromPepperSlugs: async function() {
      this.loading = true;
      try {
        await this.$store.dispatch('PULL_VIDEOS_PEPPER', {
          lessonSlug: this.lessonSlug,
          disciplineSlug: this.disciplineSlug,
        });
      } catch (e) {
        alert(
          `Algo deu errado. Erro: ${e}. Se esta mensagem de erro não estiver clara, envie essa mensagem para os desenvolvedores`,
        );
      }
      for (const videoFromPepper of this.videosFromPepper) {
        const videoInfo = {
          providerId: videoFromPepper.kalturaVideoId,
          providerType: 'KALTURA',
          duration: videoFromPepper.duration,
          description: videoFromPepper.description,
          name: videoFromPepper.name,
        };
        await this.getVideoFromBack('end', videoInfo);
      }
      this.lessonSlug = '';
      this.disciplineSlug = '';
      this.videoFromPepper = false;
      this.loading = false;
    },
    cancelVideoInsertion: async function() {
      this.newVideo = false;
      this.videoFromPepper = false;
    },
    toggleModal: async function(spot: 'start' | 'end') {
      this.newVideo = false;
      await this.addItemById('video', spot, this.createdVideoId);
      location.reload();
    },
    addItemById: async function(
      type: 'article' | 'question' | 'video',
      spot: 'start' | 'end',
      id: number,
    ) {
      if (id) {
        let duplicate, questionId, articleId, videoId;
        switch (type) {
          case 'article': {
            articleId = id;
            duplicate = this.list
              .listItems()
              .find(
                (listItem: AdminListItemModel) => listItem.articleId === id,
              );
            break;
          }
          case 'question': {
            questionId = id;
            duplicate = this.list
              .listItems()
              .find(
                (listItem: AdminListItemModel) => listItem.questionId === id,
              );
            break;
          }
          case 'video': {
            videoId = id;
            duplicate = this.list
              .listItems()
              .find((listItem: AdminListItemModel) => listItem.videoId === id);
            break;
          }
        }

        if (duplicate) {
          alert(
            `Esse item já está presente na lista! Duplicatas não são permitidas.`,
          );
        } else {
          let position;
          if (spot === 'end' && this.list.listItems().length > 0) {
            const positions = this.list
              .listItems()
              .map((listItem: ListItemModel) => listItem.position)
              .filter((position: number) => !isNaN(position));
            position = Math.max(...positions) + 1;
          } else {
            position = 0;
          }
          this.pullingItems = true;
          try {
            await this.$store.dispatch('CREATE_LIST_ITEM_FROM_ID', {
              questionId,
              articleId,
              videoId,
              listId: this.list.id,
              position,
            });
          } catch (e) {
            alert(
              `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
            );
          }
          this.pullingItems = false;
        }
      }
    },
    addQuestionByURL: async function() {
      const urls = this.questionsURLsInput.split(/\s+/).filter(Boolean);
      const regexp = /.*dex.descomplica.com.br\//;
      for (const url of urls) {
        try {
          const [
            classroom,
            discipline,
            listSlug,
            itemType,
            index,
          ] = url.replace(regexp, '').split('/');
          const questionIndex = +index;
          await this.$store.dispatch('GET_QUESTION_ID_BY_LIST_SLUG_AND_INDEX', {
            listSlug,
            index: questionIndex,
          });
          const idOfQuestion = this.idOfQuestionBySlugAndIndex(
            listSlug,
            questionIndex,
          );
          await this.addItemById('question', 'end', idOfQuestion);
          this.questionsURLsInput = this.questionsURLsInput.replace(url, '');
        } catch (e) {
          alert(
            `Algo deu errado. Verifique se os urls enviados estão corretos e separados apenas por espaços. Ou envie essas informações para os desenvolvedores: ${e}`,
          );
        }
      }
    },
    toggleAddQuestionByUrl: function() {
      this.showQuestionByUrl = !this.showQuestionByUrl;
    },
    removeItem: function(listItemId: number) {
      this.$store.dispatch('DELETE_LIST_ITEM', listItemId);
    },
    toggleRecommendation: function() {
      if (this.recommendBoards) {
        // second pass
        this.recommendBoards = false;
        this.recommendBoardSections = true;
      } else if (this.recommendBoardSections) {
        // last pass
        this.recommendBoardSections = false;
        this.$router.push(this.list.viewLink);
      } else {
        // first pass
        this.recommendBoards = true;
      }
    },
  },
});
